import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[OnlyNumbers]'
})
export class OnlyNumbersDirective {
  teclaAnterior: string = "";
  contPunto: number = 0;

  constructor(private element: ElementRef) { }

  @HostListener('keypress', ['$event'])
  onKeypressHandler(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (event.currentTarget.id == "montoForm") {
      if (charCode == 46) {
        this.contPunto = this.contPunto + 1
        let existePunto = event.currentTarget.value.indexOf('.');
        if (this.contPunto >= 2 && existePunto != -1) {
          return false
        } else {
          return true;
        }
      }
    }

    if (event.currentTarget.id == "phones") {
      if (charCode == 59) {
        return true;
      }
    }

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
